<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header bg-white p-3">
      <h5 class="mb-0">Task List</h5>
    </div>
    <div v-if="!isConnected" class="card-head box-shadow bg-white d-lg-flex align-items-left left-content-between p-15 p-sm-20 p-md-25">
      Please connect to Basecamp using Integrations page.
    </div>
    <div v-else-if="isConnected && !isAuthorized" class="card-head box-shadow bg-white d-lg-flex align-items-left left-content-between p-15 p-sm-20 p-md-25">
      The account is unauthorized to access the provider organisation.
    </div>
    <div v-else-if="isLoading" class="card-head box-shadow bg-white d-lg-flex align-items-left left-content-between p-15 p-sm-20 p-md-25">
      Fetching Data.
    </div>
    <div v-else class="card-head box-shadow bg-white d-lg-flex align-items-left left-content-between p-15 p-sm-20 p-md-25">
      <div  class="d-sm-flex align-items-center">
        <!-- First Dropdown -->
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0 p-15">
          <label for="todosetDropDown" class="form-label fw-semibold">Select a Todo Set:</label>
          <multiselect 
            v-model="selectedTodoSets" 
            :options="todoSets" 
            :multiple="true" 
            track-by="id" 
            label="title" 
            placeholder="Select Todo List(s)"
            class="project-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
            @update:modelValue="onTodoSetChange"
          ></multiselect>
        </div>

        <!-- Second Dropdown -->
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0 p-15">
          <label for="todolistDropDown" class="form-label fw-semibold">Select a Todo List:</label>
          <multiselect 
            v-model="selectedTodoLists" 
            :options="todoLists" 
            :multiple="true" 
            track-by="id" 
            label="label" 
            placeholder="Select Todo List(s)"
            class="project-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
            @update:modelValue="onTodoListChange"
            :disabled="selectedTodoSets.length <= 0"
          ></multiselect>
        </div>

        <div  class="d-sm-flex align-items-center mt-10 mt-lg-0 p-15">
          <div class="form-check">
            <input 
            :disabled="selectedTodoLists.length <= 0"
            class="form-check-input shadow-none"
            type="checkbox"
            v-model="isCompleted"
            @change="onIsCompletedChange"
            id="flexCheckDefault">
            <label class="form-check-label fw-medium position-relative top-1" for="flexCheckDefault">Completed</label>
          </div>
        </div>

        <div  class="d-sm-flex align-items-center mt-10 mt-lg-0 p-15">
          <div class="input-group">
            <input
              type="text"
              v-model="searchBox" 
              class="form-control shadow-none rounded-0"
              placeholder="Search here"
              :disabled="selectedTodoLists.length <= 0"
            />
            <button
              class="default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20"
              type="button"
              :disabled="selectedTodoLists.length <= 0"
              @click="onSearchClick"
            >
              Search
              <i
                class="flaticon-search-interface-symbol position-relative ms-5 top-1"
              ></i>
            </button>
          </div>
        </div>

        <div  class="d-sm-flex align-items-center mt-10 mt-lg-0 p-15">
          <button @click="goToCreateTaskPage"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
            Add Task
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>

      </div>
    </div>
    <div v-if="selectedTodoLists.length > 0 && todos.length == 0" class="card-body p-15 p-sm-20 p-md-25">
      No Data Found
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
      </div>
    </div>
    <div v-if="todos.length > 0 && !isLoading" class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive" style="overflow: visible;">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Title
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Description
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Todo Set
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Todo List
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Assignees
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Due Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="todo in todos" :key="todo.id">
              <td 
                class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0" 
                @click="openPopup(todo.id)" 
                style="cursor: pointer; color: blue; text-decoration: underline;"
              >
                {{ todo.title }}
              </td>
              
              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0" v-html="todo.description"></td>

              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                {{ todo.taskSet.title }}
              </td>

              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                {{ todo.parent.title }}
              </td>

              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                {{ todo.assignees.map(assignee => assignee.name).join(', ') }}
              </td>

              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                {{ new Date(todo.due_on).toLocaleDateString() }}
              </td>

              <td class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                {{ todo.completed ? 'Completed' : 'Incomplete' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="goToEditPage(todo.id)" >
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Edit
                      </a>
                    </li>
                    <li>
                      <a v-if="!todo.completed" class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="markAsComplete(todo.title, todo.completion_url)">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Click to Complete
                      </a>
                    </li>
                    <li>
                      <a v-if="todo.completed" class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="markAsInComplete(todo.title, todo.completion_url)">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Click to Incomplete
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p class="mb-0 text-paragraph">
          Showing <span class="fw-bold">{{ itemFrom }} - {{ itemTo }}</span> out of
          <span class="fw-bold">{{ totalTodos }}</span> results
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: pageIndex === 1 }">
              <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(pageIndex - 1)">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === pageIndex }">
              <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: pageIndex === totalPages }">
              <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(pageIndex + 1)">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

</template>

<script>
import { GetAllIntegrations,GetMetadataForClient } from '@/core/services/entities/integrations.service'
import { GetAllBasecampProjectTodoLists, GetAllBasecampProjectTodos, GetProjectsById, CompleteTask, InCompleteTask} from '@/core/services/entities/task.service'
import { mapGetters} from 'vuex'
import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Swal from 'sweetalert2'
import { useToast } from 'vue-toastification'
import IntegrationProviderName from '@/core/constant/integrationProviderName'

export default {
  name: "TaskList",
  components: { Multiselect },
  props: {
    BasecampProjectId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return {
      basecampProjectID: props.BasecampProjectId, // Return it to use in template
    };
  },
  data() {
    return {
      isLoading: false,
      integrations: [],
      isConnected: false, 
      isAuthorized: false, 
      todos: [], 
      searchQuery: "", 
      BasecampIntegration: null,
      pageIndex: 1, 
      itemFrom: 1, 
      itemTo: 1, 
      totalTodos: 0, 
      totalPages: 1, 
      showUpdateLightbox : false,
      projects: [],
      todoSets: [],
      todoLists: [],
      selectedTodoSets: [],
      selectedTodoLists: [],
      searchBox: "",
      isCompleted: false,
      providerAccountId:""
    };
  },
  mixins: [breadcrumbMixin],
  async mounted() {
    await this.GetProjectsById(this.basecampProjectID)
    await this.fetchIntegrationMetadata(IntegrationProviderName.Basecamp)

    const selectedTodoSetsData = sessionStorage.getItem('selectedTodoSets');
    const todoSetsDefault = selectedTodoSetsData ? JSON.parse(selectedTodoSetsData) : [];

    const selectedTodoListsData = sessionStorage.getItem('selectedTodoLists');
    const todoListsDefault = selectedTodoListsData ? JSON.parse(selectedTodoListsData) : [];
    
    const isCompleted = sessionStorage.getItem('isCompleted');
    this.isCompleted = isCompleted ? JSON.parse(isCompleted) : false;

    
    const searchBox = sessionStorage.getItem('searchBox');
    this.searchBox = searchBox ? JSON.parse(searchBox) : '';

    const todoListsData = sessionStorage.getItem('generatedTodoLists');
    this.todoLists = todoListsData ? JSON.parse(todoListsData) : [];

    if (todoSetsDefault.length >= 1) {
      this.selectedTodoSets = todoSetsDefault;
    }

    if (todoListsDefault.length >= 1) {
      this.selectedTodoLists = todoListsDefault;
    }

    //remove session after successfully mounted
    sessionStorage.removeItem('selectedTodoSets');
    sessionStorage.removeItem('selectedTodoLists');
    sessionStorage.removeItem('generatedTodoLists');
    sessionStorage.removeItem('isCompleted');
    sessionStorage.removeItem('searchBox');
  },
  methods: {
    onProjectChange() {
      // Fetch todo sets based on the selected project
      this.fetchTodoSets(this.selectedProject);
      // Reset the second and third dropdowns
      this.selectedTodoSet = null;
      this.selectedTodoList = null;
    },
    onTodoSetChange() {
      if(this.selectedTodoSets.length > 0){
        // Fetch todo lists based on the selected todo set
        this.fetchTodoLists(this.selectedProject, this.selectedTodoSets );
      }
      // Reset the third dropdown
      this.selectedTodoLists = [];
      this.todoLists = [];
      this.searchBox = '';
    },
    onTodoListChange() {
      this.pageIndex = 1;
      this.searchBox = '';
    },
    onSearchClick() {
      this.pageIndex = 1;
      if(this.selectedTodoLists.length > 0){
        // Fetch todo lists based on the selected todo
        this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
      } else {
        this.todos = [];
      }
    },
    onIsCompletedChange() {
      this.pageIndex = 1;
    },
    async fetchTodoSets(projectId) {
      this.isLoading = true;
      var project = this.projects.find(p => p.id === projectId);
      this.todoSets = project.dock.filter(d => d.name === 'todoset');
      this.isLoading = false;
    },
    async fetchTodoLists(projectId, todosetId) {
      this.isLoading = true;
      const response = await GetAllBasecampProjectTodoLists(projectId, todosetId);
      this.todoLists = response.basecampProjectTaskList;
      this.isLoading = false;
    },
    async fetchTodos(projectId, todoListId, searchBox) {
      this.isLoading = true;
      const response = await GetAllBasecampProjectTodos(projectId, todoListId, this.pageIndex, searchBox, this.isCompleted);
      this.todos = response.basecampProjectTasks;
      this.totalTodos = response.totalTodos;
      this.totalPages = response.totalPages;
      // Calculate itemFrom based on pageIndex and geared pagination logic
      const previousPagesSize = (this.pageIndex > 1 ? this.calculatePageSize(this.pageIndex - 1) : 0)
                              + (this.pageIndex > 2 ? this.calculatePageSize(this.pageIndex - 2) : 0)
                              + (this.pageIndex > 3 ? this.calculatePageSize(this.pageIndex - 3) : 0);

      this.itemFrom = previousPagesSize + 1;
      this.itemTo = this.itemFrom - 1 + this.todos.length;
      this.isLoading = false;
    },
    // Function to calculate how many items should be on the current page
    calculatePageSize(pageIndex) {
      if (pageIndex === 1) return 15;
      if (pageIndex === 2) return 30;
      if (pageIndex === 3) return 50;
      return 100; // Page 4 and onward
    },
    async GetProjectsById(projectId) {
      try {
        this.isLoading = true;
        const response = await GetProjectsById(projectId) // Replace with your API URL
        this.projects.push(response.basecampProject)
        this.selectedProject = response.basecampProject.id
        this.fetchTodoSets(response.basecampProject.id)
        this.isAuthorized = true;
        this.isLoading = false;
      } catch (error) {
        console.log(error)
        this.isLoading = false;
      }
    },
    async fetchIntegrations(filter = "") {
      let data = await GetAllIntegrations();
      if(data)
      {
        this.basecampIntegration = data.integrations.find(integration => integration.providerName == IntegrationProviderName.Basecamp);
        this.isConnected = this.basecampIntegration.isConnected
      }
    },
    async fetchIntegrationMetadata(providerName) {
      let data = await GetMetadataForClient(providerName);
      if(data)
      {
        this.providerAccountId = data.integrationMetadata.metadata.basecampAccountId
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.pageIndex = page;
        this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
      }
    },
    openPopup(id){
      const url = `https://3.basecamp.com/${this.providerAccountId}/buckets/${this.selectedProject}/todos/${id}`;
      
      const width = screen.width * 0.85;  
      const height = screen.height * 0.85;  
      const left = (screen.width - width) / 2;  
      const top = (screen.height - height) / 2;  

      window.open(url, '_blank');
    },
    goToCreateTaskPage() {
      sessionStorage.setItem('selectedTodoSets', JSON.stringify(this.selectedTodoSets));
      sessionStorage.setItem('selectedTodoLists', JSON.stringify(this.selectedTodoLists));
      sessionStorage.setItem('generatedTodoLists', JSON.stringify(this.todoLists));
      sessionStorage.setItem('isCompleted', JSON.stringify(this.isCompleted));
      sessionStorage.setItem('searchBox', JSON.stringify(this.searchBox));
      this.$router.push({
          name: 'CreateNewTaskPage',
          params: {
            projectId: this.selectedProject              
          }
      });
    },
    goToEditPage(taskId) {
      sessionStorage.setItem('selectedTodoSets', JSON.stringify(this.selectedTodoSets));
      sessionStorage.setItem('selectedTodoLists', JSON.stringify(this.selectedTodoLists));
      sessionStorage.setItem('generatedTodoLists', JSON.stringify(this.todoLists));
      sessionStorage.setItem('isCompleted', JSON.stringify(this.isCompleted));
      sessionStorage.setItem('searchBox', JSON.stringify(this.searchBox));
      this.$router.push({
          name: 'EditTaskPage',
          params: {
            projectId: this.selectedProject,
            taskId: taskId,
            isEdit: true        
          }
      });
    },
    markAsInComplete(taskTitle, completionUrl) {
      const toast = useToast();
      // Show confirmation dialog using SweetAlert2
      Swal.fire({
          title: 'Confirmation',
          text: `Do you want to mark Task "${taskTitle}" as incomplete?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            const response = await InCompleteTask(completionUrl);
            toast.info('Mark as incomplete success.', { timeout: 2000 });
            this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
          } else {
            toast.info('Mark as incomplete canceled.', { timeout: 2000 });
            this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
          }
        });
    },
    markAsComplete(taskTitle, completionUrl) {
      const toast = useToast();
      // Show confirmation dialog using SweetAlert2
      Swal.fire({
          title: 'Confirmation',
          text: `Do you want to mark Task "${taskTitle}" as complete?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            const response = await CompleteTask(completionUrl);
            toast.info('Mark as complete success.', { timeout: 2000 });
            this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
          } else {
            toast.info('Mark as complete canceled.', { timeout: 2000 });
            this.fetchTodos(this.selectedProject, this.selectedTodoLists, this.searchBox);
          }
        });
    }
  },
  computed:{...mapGetters(['allowAdd'])},
  created() {
    this.fetchIntegrations();
  }
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading {
  cursor: wait;
}
</style>


